import moment from 'moment';

export const setRegisterDate = (setState) => {
  setState(moment().format('YYYY-MM-DD HH:mm:ss'));
}
